import { render, staticRenderFns } from "./FlowMain.vue?vue&type=template&id=07a47424&scoped=true"
import script from "./FlowMain.vue?vue&type=script&lang=js"
export * from "./FlowMain.vue?vue&type=script&lang=js"
import style0 from "./FlowMain.vue?vue&type=style&index=0&id=07a47424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a47424",
  null
  
)

export default component.exports